import "@story/story_assets/dom_extend";

document.addEventSelectorListener("click", ".myform-multiselect input[type=checkbox]", function(event, target) {
	const container = target.closest(".myform-multiselect");
	const labelElement = container.querySelector(".myform-multiselect-label");
	const selectedCheckboxes = container.querySelectorAll("input[type=checkbox]:checked");

	const values = Array.from(selectedCheckboxes).map(checkbox => checkbox.value);
	const text = 0 < values.length ? values.join(", ") : labelElement.getAttribute("data-multiselect-empty");

	labelElement.textContent = text;
});

// Double range price filter functionality
function initPriceRangeFilter() {
	// Find all range wrappers (both mobile and desktop)
	const rangeWrappers = document.querySelectorAll('.range-wrapper');
	
	rangeWrappers.forEach(rangeWrapper => {
		const priceMinInput = rangeWrapper.querySelector('.price-min');
		const priceMaxInput = rangeWrapper.querySelector('.price-max');
		const rangeMinSpan = rangeWrapper.querySelector('.range-min');
		const rangeMaxSpan = rangeWrapper.querySelector('.range-max');

		if (priceMinInput && priceMaxInput && rangeMinSpan && rangeMaxSpan) {
			// Check if already initialized
			if (priceMinInput.dataset.initialized === 'true') {
				return;
			}
			
			function updateRangeValues() {
				const minValue = parseInt(priceMinInput.value);
				const maxValue = parseInt(priceMaxInput.value);
				const minRange = parseInt(priceMinInput.min);
				const maxRange = parseInt(priceMaxInput.max);
				
				if (minValue > maxValue) {
					priceMinInput.value = maxValue;
				}
				if (maxValue < minValue) {
					priceMaxInput.value = minValue;
				}
				
				const finalMinValue = parseInt(priceMinInput.value);
				const finalMaxValue = parseInt(priceMaxInput.value);
				
				rangeMinSpan.textContent = formatPrice(finalMinValue);
				rangeMaxSpan.textContent = formatPrice(finalMaxValue);
				
				// Update range fill styling
				updateRangeFill(finalMinValue, finalMaxValue, minRange, maxRange);
			}
			
			function updateRangeFill(minValue, maxValue, minRange, maxRange) {
				const range = maxRange - minRange;
				const leftPercent = ((minValue - minRange) / range) * 100;
				const rightPercent = ((maxValue - minRange) / range) * 100;
				
				rangeWrapper.style.setProperty('--range-left', `${leftPercent}%`);
				rangeWrapper.style.setProperty('--range-right', `${rightPercent}%`);
			}

			function formatPrice(price) {
				return new Intl.NumberFormat('cs-CZ').format(price) + " Kč";
			}

			priceMinInput.addEventListener("input", updateRangeValues);
			priceMaxInput.addEventListener("input", updateRangeValues);

			// Mark as initialized
			priceMinInput.dataset.initialized = 'true';
			priceMaxInput.dataset.initialized = 'true';

			updateRangeValues();
		}
	});
}

document.addEventListener("DOMContentLoaded", function() {
	// Initialize immediately
	initPriceRangeFilter();
});

// Initialize when filter buttons are clicked
document.addEventSelectorListener("click", '[data-fade="#filter"]', function(event, target) {
	setTimeout(initPriceRangeFilter, 100);
});

document.addEventSelectorListener("click", '[data-fade="#filter-mobile"]', function(event, target) {
	setTimeout(initPriceRangeFilter, 100);
});
